import _parseInt from "lodash/parseInt";
import { HTMLContent, RadioList } from '@datacamp/le-shared-components';
import { isMultiplexerSessionBroken, isMultiplexerSessionReady, MultiplexerContext } from '@datacamp/multiplexer-integration';
import Button from '@datacamp/waffles-button';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setChoice } from '../actions/actionCreators/setChoice';
import blur from '../lib/blur';
import selectCurrentChoice from '../selectors/selectCurrentChoice';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const MultipleChoice = _ref => {
  let {
    customQuestion,
    exerciseId,
    possibleAnswers
  } = _ref;
  const {
    t
  } = useTranslation('translation', {
    keyPrefix: 'ExplorableExercise'
  });
  const context = React.useContext(MultiplexerContext);
  const isMultiplexerReady = isMultiplexerSessionReady(context.status);
  const isMultiplexerBroken = isMultiplexerSessionBroken(context.status);
  const dispatch = useDispatch();
  const currentChoice = useSelector(state => selectCurrentChoice(state, exerciseId));
  const setCurrentChoice = React.useCallback(choiceValue => {
    dispatch(
    // We rely that `choiceValue` is the index
    // TODO: formalize possible_answers to also have a key associated to the value
    setChoice({
      currentChoice: _parseInt(choiceValue, 10),
      exerciseId
    }));
  }, [dispatch, exerciseId]);
  const submitChoice = React.useCallback(() => {
    blur();
    if (context.multiplexerSessionManager === undefined) {
      return;
    }
    context.multiplexerSessionManager.submitChoice(currentChoice);
  }, [context.multiplexerSessionManager, currentChoice]);
  const question = customQuestion != null ? customQuestion : 'Possible Answers';
  return ___EmotionJSX("div", {
    className: "dc-panel__body"
  }, ___EmotionJSX("h4", null, question), ___EmotionJSX(RadioList, {
    name: "exercise=".concat(exerciseId),
    onChange: setCurrentChoice,
    value: currentChoice === undefined ? '' : currentChoice.toString()
  }, possibleAnswers.map((value, index) => ___EmotionJSX(RadioList.Item, {
    key: "key-".concat(index),
    value: index.toString()
  }, ___EmotionJSX(HTMLContent, {
    html: value
  })))), ___EmotionJSX("div", {
    className: "dc-edge-to-edge"
  }, ___EmotionJSX("div", {
    className: "dc-edge-to-edge__item"
  }), ___EmotionJSX("div", {
    className: "dc-edge-to-edge__item"
  }, ___EmotionJSX(Button, {
    appearance: "primary",
    disabled: currentChoice === undefined || isMultiplexerBroken,
    intent: "success",
    loading: !isMultiplexerReady && !isMultiplexerBroken,
    onClick: submitChoice,
    size: "small"
  }, t('MultipleChoice.button')))));
};